import { render, staticRenderFns } from "./igt-sidebar-currency.vue?vue&type=template&id=a74b2af2&scoped=true&"
import script from "./igt-sidebar-currency.vue?vue&type=script&lang=js&"
export * from "./igt-sidebar-currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74b2af2",
  null
  
)

export default component.exports